<div mat-dialog-title style="background-color: #0f1642; color: #FFF; font-weight: 600;">
    {{data.title}}
</div>
<mat-dialog-content class="mat-typography" style="padding: 5px;">
    <div style="margin: 15px 0; display: block;">
        <div style="display: inline-flex;  width: 100%; margin-bottom: 5px;">
            <button mat-flat-button (click)="downloadTemplate()" class="btn-primary">
                <mat-icon>file_download</mat-icon>
                Baixar template
            </button>
            <button (click)="file.click()" mat-flat-button style="margin: 0 4px;"
                class="btn-success">
                Adicionar
            </button>

            <button *ngIf="storageData.length > 0" (click)="cleanCache()" mat-raised-button>
                Limpar
            </button>
        </div>
        <button *ngIf="fileToUpload" (click)="uploadFile()" mat-flat-button color="primary"
        type="button">
            <mat-icon>send</mat-icon> [{{fileToUpload.name}}]
        </button>
    </div>
    <div *ngIf="storageData.length == 0 && !fileToUpload" style="padding: 10px 0px 0px 15px;">
        <h3>Nenhum upload efetudado.</h3>
    </div>
    <mat-accordion>

        <mat-expansion-panel hideToggle *ngFor="let item of storageData" class="info-import-container">

            <mat-expansion-panel-header class="panel-header"
                [ngClass]="{
                    'panel-header-error': errosPerRow.length > 0,
                    'panel-header-success': item.IsSuccess
                }">
                <mat-icon mat-list-icon class="error-icon" *ngIf="errosPerRow.length > 0">warning</mat-icon>
                <mat-icon mat-list-icon class="success-icon" *ngIf="item.IsSuccess">check</mat-icon>
                <mat-panel-title [ngClass]="{'error': (errosPerRow.length > 0)}">
                    {{item.Created | date:'dd/MM/yyyy HH:mm'}} | {{item.FileName}} <mat-progress-spinner style="margin-left: auto;"
                        *ngIf="!item.isFinished" mode="indeterminate" diameter="20"></mat-progress-spinner>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngIf="item.Status">
                <div *ngIf="!item.Status">Consultando...</div>
                <div *ngIf="item.Status">
                    <p *ngIf="!item.isFinished">Processando...</p>
                    <div *ngIf="item.isFinished"
                        class="info-import-finishid">
                        <p>
                            Finalizado em: {{item.FinishAt | date:'dd/MM/yyyy HH:mm'}}
                        </p>
                        <div class="totalizer">
                            <p>Criados: {{ item.TotalCreated }}</p>
                            <p style="margin:0 15px;">Atualizados: {{ item.TotalUpdated }}</p>
                            <p>Falhas: {{ item.TotalFailed }}</p>
                        </div>
                        <button mat-mini-fab aria-label="Exportar erros para csv."
                        (click)="exportErrorsUploadToCSV()" *ngIf="paginatedErrors.length > 0">
                            <mat-icon>file_download</mat-icon>
                        </button>
                    </div>
                    <mat-accordion *ngIf="paginatedErrors.length > 0" class="error-list">
                        <mat-expansion-panel *ngFor="let rowError of paginatedErrors">
                          <mat-expansion-panel-header class="row-header">
                            Linha {{ rowError.Row }}
                          </mat-expansion-panel-header>
                          <mat-list>
                            <mat-list-item *ngFor="let erro of rowError.Erros"
                            [matTooltip]="erro" matTooltipPosition="above">
                              {{ erro }}
                            </mat-list-item>
                          </mat-list>
                        </mat-expansion-panel>
                      </mat-accordion>
                      
                      <mat-paginator 
                        [length]="errosPerRow.length" 
                        [pageSize]="pageSize" 
                        [pageSizeOptions]="[1, 5, 10]"
                        (page)="onPageChange($event)" 
                        *ngIf="errosPerRow.length">
                      </mat-paginator>
                </div>
            </div>
        </mat-expansion-panel>


    </mat-accordion>

    <input accept=".csv" #file style="display: none;" type="file" (change)="onFileSelected($event)" />
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="close()" class="btn-secondary">Fechar</button>
</mat-dialog-actions>